module.exports = __webpack_public_path__ + "img/file-bar-graph.e1370b0e.svg";